










import { Vue, Component } from 'vue-property-decorator';
import Telemetria from './Telemetria.vue';

@Component({
  components: { Telemetria },
})
export default class TelemetriaPantalla extends Vue {}
